
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2118c5ee&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Logo.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Logo.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2118c5ee!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Logo.vue"),
  /* scopeId */
  "data-v-2118c5ee",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Logo.vue
// module id = 180
// module chunks = 2